import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { Observable, catchError, map, of } from "rxjs";
import { AppStateService } from "../services/appstate.service";

export const ApplicationStartGuard: CanActivateFn = (route, state) => {
    var service = inject(AppStateService);
    return service.init().pipe(
        catchError(e => {
            console.error(e);
            return of(undefined);  //normal subscribe will continue but with undefined result
        }), map(result => result !== undefined));
}
